import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getStoreByUser, getStoreDetails, getStoreListFilter, getTaxtCertificateList } from "./Services";



export const useGetStores = () => {

  const query = useQuery(
    [endpoints.getStoreListFilter],
    () => {
      return getStoreListFilter();
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};


export const useGetStoresByUser = () => {

  const query = useQuery(
    [endpoints.getStoresByUser],
    () => {
      return getStoreByUser();
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};
export const useGetTaxCerticicates = (storeId:string) => {

  const query = useQuery(
    [endpoints.getTaxCertificates],
    () => {
      return getTaxtCertificateList(storeId);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};

export const useGetStoreDetails = (storeId:string) => {

  const query = useQuery(
    [endpoints.getStoreDetails,storeId],
    () => {
      return getStoreDetails(storeId);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );

  return query;
};
